import { EntityService } from '@/services/EntityService';
import { DevicesService } from '@/services/devices.service';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class WarehouseDevicesService extends EntityService {
  static get entity() {
    return 'warehouse';
  }

  static async getTypes(parameters = {}) {
    return DevicesService.getTypes({
      ...parameters,
      is_available: true
    });
  }

  static async getFilteredTypes(params = {}) {
    try {
      const response = await this.request().get(`${this.entity}/filters/type`, {
        params
      });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredPhones(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/filters/phone`,
        { params }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredSerialNumbers(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/filters/serial-number`,
        { params }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredList(params = {}) {
    try {
      const response = await this.request().get(`${this.entity}/filters/list`, {
        params
      });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredDeviceCodes(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/filters/device-code`,
        { params }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async checkDeviceCode(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/check-device-code`,
        {
          params
        }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
